import React, { createContext, useCallback, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

type Variant = 'success' | 'warning' | 'danger' | 'info';

interface ToastMsg {
    id: number;
    title: string;
    message: string;
    variant: Variant;
}

interface Ctx {
    showToast: (title: string, message: string, variant?: Variant) => void;
}

const ToastCtx = createContext<Ctx>({ showToast: () => {} });
export const useToast = () => useContext(ToastCtx);

let _nextId = 1;

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [items, setItems] = useState<ToastMsg[]>([]);

    const showToast = useCallback((title: string, message: string, variant: Variant = 'success') => {
        const id = _nextId++;
        setItems(prev => [...prev, { id, title, message, variant }]);
        // Auto-dismiss dopo 4s (warning/danger durano un po' di piu').
        const ttl = variant === 'danger' || variant === 'warning' ? 6000 : 4000;
        window.setTimeout(() => setItems(prev => prev.filter(x => x.id !== id)), ttl);
    }, []);

    const dismiss = (id: number) => setItems(prev => prev.filter(x => x.id !== id));

    return (
        <ToastCtx.Provider value={{ showToast }}>
            {children}
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1080 }}>
                {items.map(t => (
                    <Toast key={t.id} bg={t.variant} onClose={() => dismiss(t.id)}>
                        <Toast.Header closeButton>
                            <strong className="me-auto">{t.title}</strong>
                        </Toast.Header>
                        <Toast.Body className={t.variant === 'warning' ? '' : 'text-white'}>
                            {t.message}
                        </Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>
        </ToastCtx.Provider>
    );
};
